export default __webpack_public_path__ + "mini-icon-os-macos@2x.png";